/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { DOCUMENT } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  MatDialog,
  MatDialogConfig,
  MatDialogState,
} from "@angular/material/dialog";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer, Title } from "@angular/platform-browser";
import {
  NavigationEnd,
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
} from "@angular/router";
import { SpinnerVisibilityService } from "ng-http-loader";
import { DeviceDetectorService } from "ngx-device-detector";
import { EmbedVideoService } from "ngx-embed-video";
import { ToastrService } from "ngx-toastr";
import { setActualDimensions } from "src/app/features/liveshop/utils/helpers";
import { CartService } from "src/app/services/cart/cart.service";
import { ProgressbarService } from "src/app/services/common/progressbar/progressbar.service";
import {
  c2cEnv,
  currency,
  isClickToCallFlag,
  isFilter,
  isJDXHomePage,
  isProducts,
  isSRSMFlag,
  storeText,
  currency_symbols,
} from "src/environments/config";
import { environment } from "src/environments/environment";
import { UserService } from "valuchaincommon/common-services/user/user.service";
import { MobileRedirectDialogComponent } from "./features/all-stores/mobile-redirect-dialog/mobile-redirect-dialog.component";
import { WhiteshopLoginComponent } from "./features/auth-feature/whiteshop-login/whiteshop-login.component";
import { EnableCookiesComponent } from "./features/home-feature/enable-cookies/enable-cookies.component";
import { BusinessService } from "./services/business.service";
import { StoresService } from "./services/catalog/stores.service";
import { ApiCollectionService } from "./services/collections/api-collection.service";
import { GeoCodeService } from "./services/common/geocode/geo-code.service";
import { DialogService } from "./services/dialog-service/dialog.service";
import { LocationService } from "./services/location-service/location.service";
import { PromolinkAuthorizationService } from "./services/orderlinks/promolink-authorization.service";
import { PaymentService } from "./services/payment/payment.service";
import { LocalStorageService } from "./services/shared/local-storage/local-storage.service";
import { RegexService } from "./services/shared/regex/regex.service";
import { SlotService } from "./services/slot/slot.service";
import { HeaderComponent } from "./shared/header/header.component";
import { LoaderComponent } from "./shared/loader/loader.component";
import { v4 as uuidv4 } from "uuid";
import Cookies from "js-cookie";
import { SubSink } from "subsink";
import { UpdateAppointmentProductsService } from "./services/inventory/update-appointment-products-service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  @ViewChild(HeaderComponent) header: HeaderComponent;
  @ViewChild("audio", { static: true }) ringtone: ElementRef;
  public loader = LoaderComponent;
  audioActive = false;
  mobileRedirectDialog;
  isA2H = false;
  deferredPrompt: any;
  isClickToCall = isClickToCallFlag;
  isLandscape = false;
  currentUrl: string;
  user;
  public whiteShopLogo;
  username = "";
  isWidgetSource = false;
  windowHeight: any;
  isIosSafari = false;
  windowWidth: any;
  imageSrc: String = "../assets/icons/Shopconnect_logo_new.png";
  favIconUrl = "assets/icons/ws-icon.svg";
  isTop = true;
  linkCount = 0;
  videoIndex = 0;
  selectionPreview = false;
  isRegistrationSelected = false;
  linkCode;
  dashCode;
  orderDashboard = false;
  businessUnit;
  name;
  email;
  phoneFormat;
  phoneNumber;
  phoneNumberInvalid = false;
  emailInvalid = false;
  nameInvalid = false;
  separateDialCode = false;
  isCustomized = false;
  is3DUrl = false;
  bannerImages = [];
  isVideoPreview = false;
  public bannerImage = "../assets/images/white.jpg";
  backCount = 0;
  isBannerLoaded = false;
  isStopMovement = false;
  isDialogOpen = false;
  isARDialog = false;
  emailWishlist = false;
  emailCartlist = false;
  linkName;
  linkDescription;
  el;
  element = document.querySelector(".cursor");
  target = document.querySelector(".target");
  text = document.querySelector(".text");
  isEmailAuthEnabled = false;
  isOTPAuthEnabled = true;
  isOrderLinkFormInvalid = true;
  isProceeded: boolean;
  dataIpAddress: any;
  dataAddress: any;
  countryCode = "IN";
  redirectionOrderData;
  isPromotionBooking = false;
  public companyLiveUrl;
  isCookiesEnabled = true;
  isFontLoaded = false;
  subsink = new SubSink();
  spDetails;
  isProduction: boolean;
  isCustomizedLink = false;
  isTargetUrl =
    window.location.href.includes("target") ||
    window.location.href.includes("promolink");
  @HostListener("window:resize", ["$event"])
  onResize(event) {
    if (this.verifyLiveShopPage(this.currentUrl)) {
      return;
    }

    if (
      !(
        (localStorage.getItem("nVipaniwhiteshopkey") &&
          localStorage.getItem("nVipaniwhiteshopUser")) ||
        localStorage.getItem("retailerToken")
      ) &&
      this.router.url !== "/stores" &&
      !(
        this.router.url.includes("/business-list") ||
        this.router.url.includes("/live-shopping") ||
        (this.router.url.includes("company") &&
          !this.router.url.includes("create")) ||
        this.router.url.includes("units") ||
        this.router.url.includes("/promolink")
      ) &&
      !(
        this.router.url.includes("orderLinkCode") ||
        this.router.url.includes("target") ||
        this.router.url.includes("urlCode") ||
        this.router.url.includes("my-company/createCompany") ||
        this.router.url.includes("promolink") ||
        window.location.href.includes("orderLinkCode") ||
        window.location.href.includes("target") ||
        window.location.href.includes("urlCode") ||
        window.location.href.includes("promotionBooking") ||
        this.router.url.includes("orderDashboardCode") ||
        this.router.url.includes("3Dmodel")
      )
    ) {
      this.router.navigateByUrl("/");
    }
    this.setDimensions();
  }
  @HostListener("window:scroll", [])
  onWindowScroll() {
    const scrolled = window.scrollY;
    const total = window.innerHeight;
    this.isTop = scrolled > 0.5 * total ? false : true;
  }
  @HostListener("document:click", ["$event"])
  clickout(event) {
    this.slotService.isUserInteractionDone = true;
  }
  isMobileApp = false;
  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    public router: Router,
    public slotService: SlotService,
    private storesService: StoresService,
    public localStorageService: LocalStorageService,
    private embedVideoService: EmbedVideoService,
    private titleService: Title,
    @Inject(DOCUMENT) private _document: HTMLDocument,
    private cartService: CartService,
    public dialog: MatDialog,
    public dialogService: DialogService,
    public businessService: BusinessService,
    public toastrService: ToastrService,
    private deviceInfo: DeviceDetectorService,
    public valuChainUserService: UserService,
    public progressbarservice: ProgressbarService,
    public regexService: RegexService,
    public locationService: LocationService,
    public geoCodeService: GeoCodeService,
    public apiCollectionService: ApiCollectionService,
    public promoLinkAuthorizationService: PromolinkAuthorizationService,
    private spinnerVisibilityService: SpinnerVisibilityService,
    private paymentService: PaymentService,
    public cdRef: ChangeDetectorRef,
    private updateAppointmentProductService: UpdateAppointmentProductsService
  ) {
    document.documentElement.style.setProperty("--primary-font", "Poppins");
    document.documentElement.style.setProperty(
      "--pdp-primary-font",
      "Helvetica"
    );
    setTimeout(() => {
      this.isFontLoaded = true;
    }, 500);
    try {
      localStorage.getItem("blockUser");
      if (!localStorage) {
        this.enableCookies();
      }
    } catch (e) {
      this.enableCookies();
    }
    this.checkTrackCookie();
    this.progressbarservice.canShowLoad = true;
    this.routerEvent(this.router);
  }

  checkTrackCookie() {
    if (!Cookies.get("trackCId")) {
      let cId = uuidv4();
      let date = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
      document.cookie = `trackCId=${cId}; expires=${date}; SameSite=None; Secure`;
    }
    if (!sessionStorage.getItem("sessionId")) {
      let sessionId = uuidv4();
      var expires = new Date(
        new Date().setFullYear(new Date().getFullYear() + 1)
      );
      var sessionObject = {
        expiresAt: expires,
        sessionId: sessionId,
      };
      sessionStorage.setItem("sessionId", JSON.stringify(sessionObject));
    }
  }

  routerEvent(router: Router) {
    var asyncLoadCount = 0;
    var interval;
    router.events.subscribe((e) => {
      this.isTargetUrl =
        window.location.href.includes("target") ||
        window.location.href.includes("promolink");
      if (e instanceof NavigationEnd) {
        this.titleService.setTitle("Seamless Live Stream Shopping Experience");
      }
      if (e instanceof RouteConfigLoadStart) {
        asyncLoadCount++;
      } else if (e instanceof RouteConfigLoadEnd) {
        asyncLoadCount--;
      }
      if (asyncLoadCount) {
        if (asyncLoadCount < 2) {
          interval = setTimeout(() => {
            this.spinnerVisibilityService.show();
          }, 250);
        }
      } else {
        clearTimeout(interval);
        this.spinnerVisibilityService.hide();
      }
    });
    const url = new URL(window.location.href);
    const params = url.searchParams;
    if (params.get("isCustomized")) {
      this.isCustomized = true;
    } else {
      this.isCustomized = false;
    }
    if (params.get("forWebsite")) {
      this.slotService.websitePromolinkCB = true;
    } else {
      this.slotService.websitePromolinkCB = false;
    }
    this.is3DUrl = params.get("is3DBoard") ? true : false;
  }
  checkHeaderFooter() {
    return !(
      this.router.url.includes("/liveshop") ||
      this.router.url.includes("/video") ||
      this.router.url.includes("/payment") ||
      this.router.url.includes("/3Dmodel") ||
      window.location.href.includes("/3Dmodel") ||
      this.router.url.includes("my-company/createCompany") ||
      this.router.url.includes("orderLinkCode") ||
      window.location.href.includes("target") ||
      window.location.href.includes("urlCode") ||
      window.location.href.includes("boost-dashboard") ||
      window.location.href.includes("orderLinkCode") ||
      window.location.href.includes("promolink") ||
      this.router.url.includes("virtual-tryon")
    );
  }

  checkMobileFooter() {
    return !(
      window.location.href.includes("liveshop") ||
      window.location.href.includes("video") ||
      window.location.href.includes("3Dmodel") ||
      window.location.href.includes("appointment") ||
      window.location.href.includes("stores") ||
      window.location.href.includes("bulkupload") ||
      window.location.href.includes("payment") ||
      window.location.href.includes("units") ||
      window.location.href.includes("promolink") ||
      this.router.url.includes("urlCode") ||
      this.router.url.includes("my-company/create") ||
      this.router.url.includes("quotations/details") ||
      this.router.url.includes("orderLinkCode") ||
      window.location.href.includes("target") ||
      window.location.href.includes("boost-dashboard") ||
      window.location.href.includes("orderLinkCode") ||
      this.router.url.includes("virtual-tryon") ||
      (window.location.href.includes("myorders/order-details") &&
        this.isMobileDevice())
    );
  }

  async ngOnInit(): Promise<void> {
    if (
      localStorage.getItem("retailerToken") ||
      localStorage.getItem("nVipaniwhiteshopkey")
    ) {
      this.slotService.isUserLoggedIn.next(true);
    }

    this.subsink.add(
      this.slotService.detachChangeListeners.subscribe((detach) => {
        if (!detach) this.cdRef.reattach();
        else this.cdRef.detach();
      })
    );
    if (window.location.href.includes("3Dmodel")) {
      this.isARDialog = true;
    }
    window.addEventListener(
      "widgetClose",
      function () {
        console.log("widget Closed");
        if (localStorage.getItem("widgetRegistrationUser")) {
          localStorage.removeItem("nVipaniwhiteshopkey");
          localStorage.removeItem("nVipaniwhiteshopUser");
          localStorage.removeItem("user");
          if (sessionStorage.getItem("promoLinkData")) {
            localStorage.setItem("escapeRedirect", "true");
          }
          localStorage.removeItem("widgetRegistrationUser");
        }
      },
      false
    );
    if (window.location.href.includes("source=widget")) {
      this.isWidgetSource = true;
    }
    if (window.location.href.includes("source=email")) {
      const url = new URL(window.location.href);
      const params = url.searchParams;
      if (params.get("customOrder")) {
        if (localStorage.getItem("nVipaniwhiteshopkey") != null) {
          this.updateAppointmentProductService
            .addProductsToCart(params.get("customOrder"))
            .subscribe(
              (res) => {
                window.location.href =
                  window.location.origin +
                  "/myorders/consumer-cart?source=widget";
                this.isWidgetSource = true;
              },
              (err) => {
                window.location.href =
                  window.location.origin +
                  "/myorders/consumer-cart?source=widget";
                this.isWidgetSource = true;
                this.toastrService.error(err.error.message, null, {
                  timeOut: 2000,
                });
              }
            );
        } else {
          this.emailCartlist = true;
          localStorage.setItem("redirectCartlist", JSON.stringify("true"));
          localStorage.setItem("customOrderId", params.get("customOrder"));
          localStorage.setItem("consumerId", params.get("consumerId"));
          window.location.href = params.get("redirecturl") + "?showIframe=true";
        }
      }
    }
    let isCookiesEnabled = false;
    if (localStorage.getItem("retailerToken")) {
      this.localStorageService.isRetailerVersion = true;
    }
    if (localStorage.getItem("nVipaniwhiteshopkey")) {
      this.slotService.getBuyerLocale();
    }
    try {
      if (window.localStorage) {
        isCookiesEnabled = true;
      }
    } catch (e) {
      console.log(e);
    }
    if (isCookiesEnabled) {
      if (this.deviceInfo && this.deviceInfo.os.toLowerCase() === "ios") {
        if (!this.deviceInfo.browser.toLowerCase().includes("safari")) {
          this.isIosSafari = true;
        }
      }
      // if (!this.isIosSafari) {
      //   this.ringtone.nativeElement.src = "/assets/phone.mp3";
      // }
      document.documentElement.style.setProperty("--primary-color", "#28a4dd");
      document.documentElement.style.setProperty("--primary-font", "Poppins");
      document.documentElement.style.setProperty(
        "--pdp-primary-font",
        "Helvetica"
      );
      this.localStorageService.activateRingtone.subscribe((isActive) => {
        if (isActive && this.isIosSafari) {
          this.audioActive = true;
          this.ringtone.nativeElement.play();
          setTimeout(() => {
            this.ringtone.nativeElement.pause();
            this.ringtone.nativeElement.src = "/assets/phone.mp3";
            this.localStorageService.isRingtoneActivated = true;
          }, 500);
        }
      });
      this.localStorageService.playRingtone.subscribe((isPlay) => {
        if (!this.audioActive && isPlay) {
          if (!this.isIosSafari) {
            this.ringtone.nativeElement.src = "/assets/phone.mp3";
          }
          this.audioActive = true;
        }
        if (isPlay) {
          this.ringtone.nativeElement.play();
        } else {
          this.ringtone.nativeElement.pause();
        }
      });
      this.setDimensions();
      this.localStorageService.isLogoUpdated.subscribe((data) => {
        if (data && data.length) {
          this.whiteShopLogo = data[0];
        }
      });
      this.iconRegistry.addSvgIcon(
        "arrowIcon",
        this.sanitizer.bypassSecurityTrustResourceUrl(
          "assets/icons/left-arr.svg"
        )
      );
      this.iconRegistry.addSvgIcon(
        "refreshingIcon",
        this.sanitizer.bypassSecurityTrustResourceUrl(
          "assets/icons/refreshing_theme.svg"
        )
      );
      this.iconRegistry.addSvgIcon(
        "dashboardIcon",
        this.sanitizer.bypassSecurityTrustResourceUrl(
          "assets/icons/dashboard.svg"
        )
      );
      this.iconRegistry.addSvgIcon(
        "threeSixtyIcon",
        this.sanitizer.bypassSecurityTrustResourceUrl(
          "assets/icons/threesixty_theme.svg"
        )
      );
      this.iconRegistry.addSvgIcon(
        "similarIcon",
        this.sanitizer.bypassSecurityTrustResourceUrl(
          "assets/icons/similarIcon.svg"
        )
      );
      this.iconRegistry.addSvgIcon(
        "rotateIcon",
        this.sanitizer.bypassSecurityTrustResourceUrl(
          "assets/icons/rotate_theme.svg"
        )
      );
      this.iconRegistry.addSvgIcon(
        "eyeIcon",
        this.sanitizer.bypassSecurityTrustResourceUrl(
          "assets/icons/blueEye.svg"
        )
      );
      this.iconRegistry.addSvgIcon(
        "eyeSlashIcon",
        this.sanitizer.bypassSecurityTrustResourceUrl(
          "assets/icons/blueEyeOff.svg"
        )
      );
      setTimeout(() => {
        this.setFavIcon();
      }, 1000);
      if (
        window.location.hostname.startsWith("jdx") ||
        window.location.hostname.includes("highlineunitedmarketplace") ||
        window.location.hostname.includes("patrician") ||
        window.location.hostname.includes("demo") ||
        window.location.hostname.includes("intercept")
      ) {
        storeText.text = "Brand";
        currency.currency = "$";
        isJDXHomePage.flag = true;
        if (window.location.hostname.startsWith("jdx")) {
          this.imageSrc = "../assets/icons/JDX-Logo.png";
        } else if (
          window.location.hostname.includes("highlineunitedmarketplace")
        ) {
          this.imageSrc = "../assets/icons/highline-united-logo.png";
        } else if (window.location.hostname.includes("patrician")) {
        } else if (window.location.hostname.includes("suvidha")) {
        } else if (window.location.hostname.includes("mattress")) {
        }
        if (window.location.href.includes("bulkupload")) {
          const uploadType = localStorage.getItem("bulkUpload");
          this.router.navigateByUrl(
            uploadType === "Consumer"
              ? "/my-company"
              : uploadType === "BusinessUnit"
              ? "/my-company/my-units"
              : "/stores"
          );
        }
        if (
          !window.location.href.includes("code") &&
          !window.location.href.includes("3Dmodel") &&
          !window.location.href.includes("appointment") &&
          !window.location.href.includes("order") &&
          !window.location.href.includes("stores") &&
          !window.location.href.includes("payment") &&
          !window.location.href.includes("my-company/create") &&
          !window.location.href.includes("bulkupload") &&
          !window.location.href.includes("company") &&
          !window.location.href.includes("units") &&
          !window.location.href.includes("promolink") &&
          !window.location.href.includes("orderLinkCode") &&
          !window.location.href.includes("orderDashboardCode") &&
          !window.location.href.includes("target") &&
          !window.location.href.includes("urlCode") &&
          !window.location.href.includes("clicktocall") &&
          !window.location.href.includes("promotionBooking") &&
          !window.location.href.includes("joincall") &&
          !window.location.href.includes("myaddresses") &&
          !window.location.href.includes("privacy-policy") &&
          !window.location.href.includes("mywishlist") &&
          !window.location.href.includes("getsummary") &&
          !window.location.href.includes("quotations")
        ) {
          if (localStorage.getItem("retailerToken")) {
            if (this.isMobileDevice()) {
              this.router.navigateByUrl("/homePage");
            } else {
              this.router.navigateByUrl("/");
            }
          } else if (localStorage.getItem("user")) {
            this.router.navigateByUrl("/appointments");
          } else {
            let dialogRef = this.dialogService.openMatDialog(
              WhiteshopLoginComponent,
              true,
              true,
              null,
              null,
              true,
              true
            );
            document
              .getElementById("ws-body")
              .classList.add("cdk-global-scrollblock");
            dialogRef.afterClosed().subscribe((res) => {
              document
                .getElementById("ws-body")
                .classList.remove("cdk-global-scrollblock");
            });
          }
        }
      } else {
        if (window.location.href.includes("bulkupload")) {
          const uploadType = localStorage.getItem("bulkUpload");
          this.router.navigateByUrl(
            uploadType === "Consumer"
              ? "/my-company"
              : uploadType === "BusinessUnit"
              ? "/my-company/my-units"
              : "/stores"
          );
        } else if (
          !window.location.href.includes("code") &&
          !window.location.href.includes("3Dmodel") &&
          !window.location.href.includes("appointment") &&
          !window.location.href.includes("payment") &&
          !window.location.href.includes("order") &&
          !window.location.href.includes("my-company/create") &&
          !window.location.href.includes("stores") &&
          !window.location.href.includes("bulkupload") &&
          !window.location.href.includes("company") &&
          !window.location.href.includes("units") &&
          !window.location.href.includes("promolink") &&
          !window.location.href.includes("orderLinkCode") &&
          !window.location.href.includes("orderDashboardCode") &&
          !window.location.href.includes("target") &&
          !window.location.href.includes("urlCode") &&
          !window.location.href.includes("clicktocall") &&
          !window.location.href.includes("promotionBooking") &&
          !window.location.href.includes("joincall") &&
          !window.location.href.includes("myaddresses") &&
          !window.location.href.includes("privacy-policy") &&
          !window.location.href.includes("mywishlist") &&
          !window.location.href.includes("getsummary") &&
          !window.location.href.includes("quotations")
        ) {
          if (localStorage.getItem("retailerToken")) {
            if (this.isMobileDevice()) {
              this.router.navigateByUrl("/homePage");
            } else {
              this.router.navigateByUrl("/");
            }
          } else if (localStorage.getItem("user")) {
            const isAppointment = JSON.parse(
              localStorage.getItem("companyConfig")
            )
              ? JSON.parse(localStorage.getItem("companyConfig")).whiteshop
                  .isScheduledAppointmentsEnabled
              : true;
            if (isAppointment) {
              this.router.navigateByUrl("/appointments");
            } else {
              this.router.navigateByUrl("/myorders");
            }
          } else {
            let dialogRef = this.dialogService.openMatDialog(
              WhiteshopLoginComponent,
              true,
              true,
              null,
              null,
              true,
              true
            );
            document
              .getElementById("ws-body")
              .classList.add("cdk-global-scrollblock");
            dialogRef.afterClosed().subscribe((res) => {
              document
                .getElementById("ws-body")
                .classList.remove("cdk-global-scrollblock");
            });
          }
        }
      }
      if (
        window.location.href.includes("mywishlist") &&
        !localStorage.getItem("user")
      ) {
        const url = new URL(window.location.href);
        const params = url.searchParams;

        const config =
          localStorage.getItem("config") ||
          localStorage.getItem("companyConfig")
            ? JSON.parse(
                localStorage.getItem("config") ||
                  localStorage.getItem("companyConfig")
              )
            : null;
        const customerUrl = config?.whiteshop?.clickToCall?.originUrl;
        if (customerUrl && params.get("fromEmail")) {
          this.emailWishlist = true;
          localStorage.setItem("redirectWishlist", JSON.stringify("true"));
          window.location.href = customerUrl + "?showIframe=true";
        }
      }
      if (window.location.href.includes("order")) {
        const url = new URL(window.location.href);
        const params = url.searchParams;
        if (params.get("userType") && params.get("orderId")) {
          if (
            params.get("userType") === "b2cUser" &&
            !localStorage.getItem("user")
          ) {
            const config = localStorage.getItem("companyConfig")
              ? JSON.parse(localStorage.getItem("companyConfig"))
              : null;
            const customerUrl = config?.whiteshop?.clickToCall?.originUrl;
            if (customerUrl) {
              const redirectOrder = {
                orderId: params.get("orderId"),
                showIframe: true,
              };
              localStorage.setItem(
                "redirectOrder",
                JSON.stringify(redirectOrder)
              );
              window.location.href = customerUrl + "?showIframe=true";
            } else {
              this.redirectionOrderData = {
                orderId: params.get("orderId"),
                showIframe: true,
                isNotRedirected: true,
              };
            }
          } else {
            this.slotService.openOrder.next(params.get("orderId"));
            this.router.navigateByUrl("/myorders");
          }
        } else if (params.get("orderId")) {
          this.slotService.openOrder.next(params.get("orderId"));
          this.router.navigateByUrl("/myorders");
        }
      }
      if (isJDXHomePage.flag) {
        if (!localStorage.getItem("config")) {
          const code = window.location.hostname.includes(
            "highlineunitedmarketplace"
          )
            ? "HIGHLINE"
            : window.location.hostname.includes("patrician")
            ? "PATRICIANASH"
            : "";
          if (code && code.length) {
            this.localStorageService.getCompanyConfig(code).subscribe((res) => {
              if (res) {
                if (res.whiteshop?.currency?.length) {
                  currency.currency = currency_symbols[res.whiteshop.currency];
                }
                localStorage.setItem("config", JSON.stringify(res));
                localStorage.setItem(
                  "isLanguageTranslation",
                  res["whiteshop"].isLanguageTranslation
                );
                this.localStorageService.islocalStorageChannelsUpdated.next(
                  true
                );
              }
            });
          }
        }
      } else {
        this.localStorageService.islocalStorageChannelsUpdated.next(true);
      }
      if (
        window.location.href.includes("srsm") ||
        window.location.href.includes("srshopping")
      ) {
        isSRSMFlag.flag = true;
        isFilter.flag = false;
        isProducts.flag = true;
        this.imageSrc = "../assets/icons/SRlogo.png";
      }

      if (isSRSMFlag.flag) {
        if (!localStorage.getItem("config")) {
          const code =
            window.location.href.includes("srsm") ||
            window.location.href.includes("srshopping")
              ? "SRSM"
              : "";
          if (code && code.length) {
            this.localStorageService.getCompanyConfig(code).subscribe((res) => {
              if (res) {
                if (res.whiteshop?.currency?.length) {
                  currency.currency = currency_symbols[res.whiteshop.currency];
                }
                localStorage.setItem("config", JSON.stringify(res));
                localStorage.setItem(
                  "isLanguageTranslation",
                  res["whiteshop"].isLanguageTranslation
                );
                this.localStorageService.islocalStorageChannelsUpdated.next(
                  true
                );
              }
            });
          }
        }
      }
      this.localStorageService.islocalStorageChannelsUpdated.subscribe(
        (isUpdated) => {
          this.setFavIcon();
          let myCompanyConfig = JSON.parse(
            localStorage.getItem("config")
              ? localStorage.getItem("config")
              : localStorage.getItem("companyConfig")
          );
          if (this.redirectionOrderData?.isNotRedirected) {
            const customerUrl =
              myCompanyConfig?.whiteshop?.clickToCall?.originUrl;
            if (customerUrl) {
              const redirectOrder = {
                orderId: this.redirectionOrderData.orderId,
                showIframe: true,
              };
              localStorage.setItem(
                "redirectOrder",
                JSON.stringify(redirectOrder)
              );
              window.location.href = customerUrl + "?showIframe=true";
              this.redirectionOrderData = undefined;
            }
          }
          if (this.emailWishlist) {
            localStorage.setItem("redirectWishlist", JSON.stringify("true"));
            this.emailWishlist = false;
          }
          if (this.emailCartlist) {
            localStorage.setItem("redirectCartlist", JSON.stringify("true"));
            this.emailCartlist = false;
          }
        }
      );
      if (localStorage.getItem("user")) {
        this.username = JSON.parse(localStorage.getItem("user")).displayName
          ? JSON.parse(localStorage.getItem("user")).displayName
          : JSON.parse(localStorage.getItem("user")).username;
        let code;
        if (
          window.location.href.includes("srsm") ||
          window.location.href.includes("srshopping")
        ) {
          code = "SRSM";
        } else if (
          window.location.hostname.includes("highlineunitedmarketplace")
        ) {
          code = "HIGHLINE";
        } else if (window.location.hostname.includes("mattress")) {
          code = "MATTRESS";
        } else if (
          window.location.hostname.startsWith("qa") ||
          window.location.hostname.startsWith("staging")
        ) {
          code = "WHITESHOP";
        } else if (window.location.hostname.includes("kilburn")) {
          code = "KILBURN";
        }

        if (code && code.length) {
          this.localStorageService.getCompanyConfig(code).subscribe((res) => {
            if (res) {
              if (res.whiteshop?.currency?.length) {
                currency.currency = currency_symbols[res.whiteshop.currency];
              }
              localStorage.setItem("config", JSON.stringify(res));
              localStorage.setItem(
                "isLanguageTranslation",
                res["whiteshop"].isLanguageTranslation
              );
              this.localStorageService.islocalStorageChannelsUpdated.next(true);
            }
          });
        }
      } else if (!localStorage.getItem("companyConfig")) {
        setTimeout(() => {
          if (!localStorage.getItem("companyConfig")) {
            let code;
            if (window.location.hostname.includes("kilburn")) {
              code = "KILBURN";
            } else if (window.location.hostname.includes("mattress")) {
              code = "MATTRESS";
            }
            this.localStorageService.getCompanyConfig(code).subscribe(
              (res) => {
                if (res) {
                  if (res.whiteshop?.currency?.length) {
                    currency.currency =
                      currency_symbols[res.whiteshop.currency];
                  }
                  localStorage.setItem("config", JSON.stringify(res));
                  localStorage.setItem("companyConfig", JSON.stringify(res));
                  localStorage.setItem(
                    "isLanguageTranslation",
                    res["whiteshop"].isLanguageTranslation
                  );
                }
                this.localStorageService.islocalStorageChannelsUpdated.next(
                  true
                );
              },
              (err) => {
                this.localStorageService.islocalStorageChannelsUpdated.next(
                  true
                );
              }
            );
          }
        }, 1000);
      }
      window.addEventListener("beforeinstallprompt", (e) => {
        this.deferredPrompt = e;
        this.deferredPrompt.preventDefault();
        setTimeout(() => {
          // Disabling Add to home
          // this.isA2H = true;
        }, 10000);
      });

      this.router.events.subscribe((res: any) => {
        if (res.url) {
          this.currentUrl = res.url;
        }

        if (!res.url || this.verifyLiveShopPage(res.url)) {
          return;
        }

        if (res instanceof NavigationEnd) {
          if (
            res.url === "/" &&
            localStorage.getItem("user") &&
            !window.location.href.includes("externalOffer") &&
            !window.location.href.includes("target") &&
            !window.location.href.includes("urlCode") &&
            !window.location.href.includes("clicktocall") &&
            !window.location.href.includes("promotionBooking") &&
            !this.linkCount
          ) {
            if (
              JSON.parse(localStorage.getItem("user")) &&
              JSON.parse(localStorage.getItem("user")).type &&
              JSON.parse(localStorage.getItem("user")).type === "B2C"
            ) {
              this.router.navigateByUrl("/appointments");
            } else {
              this.router.navigateByUrl("homePage");
            }
          } else if (res.url === "/learnmore") {
            this.router.navigateByUrl("learnmore");
          } else if (
            !res.url.includes("type=External") &&
            !res.url.includes("liveshop") &&
            !res.url.includes("3Dmodel") &&
            !res.url.includes("orderLinkCode") &&
            !res.url.includes("orderDashboardCode") &&
            !res.url.includes("target") &&
            !res.url.includes("urlCode") &&
            !res.url.includes("clicktocall") &&
            !res.url.includes("promotionBooking") &&
            !res.url.includes("joincall") &&
            !res.url.includes("payment") &&
            !res.url.includes("promolink") &&
            !res.url.includes("my-company/createCompany") &&
            !res.url.includes("virtual-tryon") &&
            !res.url.includes("myorders/consumer-cart") &&
            res.url !== "/" &&
            !localStorage.getItem("retailerToken") &&
            !localStorage.getItem("nVipaniwhiteshopkey")
          ) {
            this.localStorageService.resetUserData();
            this.router.navigateByUrl("/");
            this.localStorageService.getConfig();
          }
          window.scrollTo(0, 0);
          if (this.header) {
            this.header.setHighlight(res.url);
          }
        }
        if (
          this.slotService.selectedSlotData.selectedBusinessUnit &&
          this.slotService.selectedSlotData.selectedBusinessUnit["_id"] &&
          !sessionStorage.getItem("currentBusinessUnitId")
        ) {
          this.localStorageService.setCurrentBusinessUnit(
            this.slotService.selectedSlotData.selectedBusinessUnit["_id"]
          );
        }
        if (
          sessionStorage.getItem("currentBusinessUnitId") &&
          !(
            this.slotService.selectedSlotData.selectedBusinessUnit &&
            this.slotService.selectedSlotData.selectedBusinessUnit["_id"]
          )
        ) {
          const businessUnits = JSON.parse(
            localStorage.getItem("businessUnits")
          );
          if (businessUnits && businessUnits.length) {
            const index = businessUnits.findIndex(
              (eachBU) =>
                eachBU.businessUnit._id ===
                sessionStorage.getItem("currentBusinessUnitId")
            );
            if (index !== -1) {
              this.slotService.selectedSlotData.selectedBusinessUnit =
                businessUnits[index].businessUnit;
            }
          }
        }
      });
      if (
        sessionStorage.getItem("currentBusinessUnit") !== null &&
        sessionStorage.getItem("currentBusinessUnit") !== "undefined"
      ) {
        this.slotService.currentBusinessUnit = JSON.parse(
          sessionStorage.getItem("currentBusinessUnit")
        );
        localStorage.setItem(
          "selectedBusinessUnitId",
          this.slotService.currentBusinessUnit._id
        );
        this.valuChainUserService.currentBusinessUnitDetailBS.next(
          this.slotService.currentBusinessUnit
        );
        this.valuChainUserService.selectedBusinessUnitData = this.slotService.currentBusinessUnit;
      } else {
        const businessUnits = JSON.parse(localStorage.getItem("businessUnits"));
        if (businessUnits && businessUnits.length) {
          const index = businessUnits.findIndex(
            (eachBU) =>
              eachBU.businessUnit._id ===
              localStorage.getItem("selectedBusinessUnitId")
          );
          if (index !== -1) {
            sessionStorage.setItem(
              "currentBusinessUnit",
              JSON.stringify(businessUnits[index].businessUnit)
            );
            this.slotService.currentBusinessUnit = JSON.parse(
              sessionStorage.getItem("currentBusinessUnit")
            );
            this.valuChainUserService.currentBusinessUnitDetailBS.next(
              this.slotService.currentBusinessUnit
            );
            this.valuChainUserService.selectedBusinessUnitData = this.slotService.currentBusinessUnit;
          } else {
            const index = businessUnits.findIndex(
              (eachBU) => eachBU.defaultBusinessUnit === true
            );
            if (index === -1) {
              sessionStorage.setItem(
                "currentBusinessUnit",
                JSON.stringify(businessUnits[0].businessUnit)
              );
            } else {
              sessionStorage.setItem(
                "currentBusinessUnit",
                JSON.stringify(businessUnits[index].businessUnit)
              );
            }
            this.slotService.currentBusinessUnit = JSON.parse(
              sessionStorage.getItem("currentBusinessUnit")
            );
            this.valuChainUserService.currentBusinessUnitDetailBS.next(
              this.slotService.currentBusinessUnit
            );
            this.valuChainUserService.selectedBusinessUnitData = this.slotService.currentBusinessUnit;
          }
          if (localStorage.getItem("retailerToken")) {
            this.slotService.setCurrencyObject();
          }
        }
      }
      if (localStorage.getItem("nVipaniwhiteshopkey")) {
        const cartId = localStorage.getItem("cartId");
        if (cartId) {
          this.cartService.getCart(cartId).subscribe((res) => {
            this.slotService.cart = res.products;
          });
        }
      }
      if (
        this.isMobileDevice() ||
        (this.isTabDevice() && screen.width < 1200)
      ) {
        if (!window.matchMedia("(orientation: portrait)").matches) {
          this.isLandscape = true;
        }
        window.addEventListener("orientationchange", () => {
          if (
            screen.orientation.angle === 90 ||
            screen.orientation.angle === -90 ||
            screen.orientation.angle === 270
          ) {
            this.isLandscape = true;
          } else {
            this.isLandscape = false;
          }
        });
      }
    }
  }

  ngOnDestroy() {
    this.subsink.unsubscribe();
  }

  ngAfterViewInit() {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    let key = params.get("key");
    let showIframe = params.get("showIframe");
    let promotionBooking = params.get("promotionsBooking");
    if (promotionBooking) {
      var script = document.createElement("script");
      let keyText = `window.c2cKey = ` + "'" + key + "';";
      script.innerText = keyText;
      document.head.appendChild(script);
      var script1 = document.createElement("script");
      script1.src = `https://c2c-sc.s3.ap-south-1.amazonaws.com/c2c${
        c2cEnv[environment.name]
      }.js`;
      document.head.appendChild(script1);
    }
  }
  addIcons() {
    this.iconRegistry.addSvgIcon(
      "volumeOutline",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/volume-outline.svg"
      )
    );
    this.iconRegistry.addSvgIcon(
      "volume",
      this.sanitizer.bypassSecurityTrustResourceUrl("assets/icons/volume.svg")
    );
    this.iconRegistry.addSvgIcon(
      "volumeOff",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/volume_mute_off.svg"
      )
    );
    this.iconRegistry.addSvgIcon(
      "volumeOffOutline",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/mute-outline.svg"
      )
    );
    this.iconRegistry.addSvgIcon(
      "menuIcon",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/menu_black.svg"
      )
    );
    this.iconRegistry.addSvgIcon(
      "homeIcon",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/home_black.svg"
      )
    );
    this.iconRegistry.addSvgIcon(
      "arrowBack",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/arrow_back_black_24dp.svg"
      )
    );

    this.iconRegistry.addSvgIcon(
      "arrowForward",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/arrow_forward_black_24dp.svg"
      )
    );
    this.iconRegistry.addSvgIcon(
      "liveshopOutline",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/video-camera-outline.svg"
      )
    );
    this.iconRegistry.addSvgIcon(
      "eventIcon",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/event_black_24dp.svg"
      )
    );
    this.iconRegistry.addSvgIcon(
      "videoCamera",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/video_camera_front_white.svg"
      )
    );
    this.iconRegistry.addSvgIcon(
      "chatIcon",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/chat_theme.svg"
      )
    );
    this.iconRegistry.addSvgIcon(
      "shareIcon",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/share-outline-black.svg"
      )
    );
    this.iconRegistry.addSvgIcon(
      "userOutlineIcon",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/user-outline.svg"
      )
    );
    this.iconRegistry.addSvgIcon(
      "addToCart",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/add-to-basket-order-link.svg"
      )
    );

    this.iconRegistry.addSvgIcon(
      "infoIcon",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/info-order-link.svg"
      )
    );

    this.iconRegistry.addSvgIcon(
      "angleDown",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/polygon_4.svg"
      )
    );
    this.iconRegistry.addSvgIcon(
      "consumerCart",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/consumer-cart.svg"
      )
    );
    this.iconRegistry.addSvgIcon(
      "rightArrow",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/arrow-right-solid.svg"
      )
    );
    this.iconRegistry.addSvgIcon(
      "customerCartIcon",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/cart-white.svg"
      )
    );
  }
  redirectToLink(res) {
    if (res.url && !window.location.href.includes("orderLinkCode")) {
      if (!!(window.history && history.pushState)) {
        history.pushState(null, null, res.url);
      }
    }
  }
  setFavIcon() {
    let myCompanyConfig = JSON.parse(
      localStorage.getItem("config")
        ? localStorage.getItem("config")
        : localStorage.getItem("companyConfig")
        ? localStorage.getItem("companyConfig")
        : null
    );
    if (
      myCompanyConfig !== null &&
      myCompanyConfig.whiteshop &&
      myCompanyConfig.whiteshop.favIcon &&
      (!localStorage.getItem("user") ||
        window.location.origin === myCompanyConfig.domainUrl)
    ) {
      this.favIconUrl = myCompanyConfig.whiteshop.favIcon;
    } else {
      if (window.location.hostname.startsWith("jdx")) {
        this.favIconUrl = "assets/icons/JDX-icon.svg";
      } else if (
        window.location.hostname.includes("highlineunitedmarketplace")
      ) {
        this.favIconUrl = "assets/icons/highline-united-favicon.png";
      } else if (window.location.hostname.includes("patrician")) {
        this.favIconUrl = "assets/icons/patrician-fav.svg";
      } else if (window.location.hostname.includes("suvidha")) {
        this.favIconUrl = "assets/icons/suvidha-fav.svg";
      } else if (window.location.hostname.includes("mattress")) {
        this.favIconUrl = "assets/icons/mattress-logo.svg";
      } else if (
        window.location.href.includes("srsm") ||
        window.location.href.includes("srshopping")
      ) {
        this.favIconUrl = "assets/icons/sr.svg";
      } else if (window.location.href.includes("thehappybabystore")) {
        this.favIconUrl = "assets/icons/Happybabystore_logo.jpg";
      } else {
        this.favIconUrl = "assets/icons/newSCLogo.png";
      }
    }
    let favIcon = this.favIconUrl;
    this._document.getElementById("appFavicon").setAttribute("href", favIcon);
  }
  getLinkData(geoCodeData, ipAddressData, userObj) {
    this.slotService.geoCodeData = geoCodeData;
    this.slotService.ipAddressData = ipAddressData.ip;
    if (!this.isProceeded) {
      this.isProceeded = false;
      this.slotService
        .checkLinkData({
          linkCode: this.linkCode,
          address: geoCodeData ? geoCodeData : undefined,
          ipAddress: ipAddressData.ip,
          username: userObj.username,
        })
        .subscribe(
          (result) => {
            result["orderLink"]["spDetails"] = this.spDetails;
            this.apiCollectionService.spDetails = this.spDetails;
            this.getPrimarySalesPersonId(result);
            if (Object.keys(result).length) {
              this.selectionPreview = false;
              this.promoLinkAuthorizationService.getCartData({
                data: result,
                email: userObj.email,
              });
            }
          },
          (err) => {
            this.toastrService.error("No order link for this email", null, {
              timeOut: 2000,
            });
            this.router.navigateByUrl("/");
          }
        );
    }
  }

  verifyLiveShopPage(url) {
    if (
      url &&
      ((url.includes("liveshop") && url.includes("external")) ||
        (url.includes("liveshop") && url.includes("spot")) ||
        (url.includes("liveshop") && url.includes("b2cexternal")) ||
        url.includes("clicktocall") ||
        url.includes("joincall"))
    ) {
      return true;
    }
  }

  openRedirectToAppPrompt = (url) => {
    const urlObject = new URL(url);
    let MobileRedirectDialogConfig = new MatDialogConfig();
    MobileRedirectDialogConfig.maxWidth = "100vw";
    MobileRedirectDialogConfig.width = "100vw";
    MobileRedirectDialogConfig.height = "150px";
    MobileRedirectDialogConfig.position = { bottom: "0" };
    MobileRedirectDialogConfig.disableClose = false;
    MobileRedirectDialogConfig.hasBackdrop = false;
    MobileRedirectDialogConfig.data = {
      isSelections: true,
      newLogin: true,
      widgetLogin: true,
    };
    this.mobileRedirectDialog = this.dialog.open(
      MobileRedirectDialogComponent,
      MobileRedirectDialogConfig
    );
    this.mobileRedirectDialog.componentInstance.onOpenApp.subscribe(
      (openApp) => {
        if (openApp) {
          const promotionCode = urlObject.searchParams.get("orderLinkCode");
          setTimeout(function () {
            window.location.replace(
              "https://play.google.com/store/apps/details?id=com.shopconnect"
            );
          }, 7500);
          window.location.replace(
            "shopconnect://app/promotions/details/" + promotionCode
          );
        }
        this.mobileRedirectDialog.close();
      }
    );
    this.promoLinkAuthorizationService.closeMobileRedirectDialog.subscribe(
      (closeDialog) => {
        if (
          closeDialog &&
          this.mobileRedirectDialog &&
          this.mobileRedirectDialog.getState() === MatDialogState.OPEN
        ) {
          this.mobileRedirectDialog.close();
        }
      }
    );
  };

  errHandler() {
    if (localStorage.getItem("user")) {
      let userObj = JSON.parse(localStorage.getItem("user"));
      this.getLinkData(null, {}, userObj);
    } else {
      this.selectionPreview = true;
    }
  }

  installPrompt() {
    this.isA2H = false;
    this.deferredPrompt.prompt();
    // Wait for the user to respond to the prompt
    this.deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === "accepted") {
        console.log("User accepted the A2HS prompt");
      } else {
        console.log("User dismissed the A2HS prompt");
      }
      this.deferredPrompt = null;
    });
  }
  close() {
    this.isA2H = false;
  }
  isHeaderSticky() {
    return window.innerWidth > 599 && !this.router.url.includes("/liveshop");
  }
  isPaddingApplied() {
    return (
      window.innerWidth > 599 &&
      ((!JSON.parse(localStorage.getItem("user")) &&
        this.router.url.includes("/stores") &&
        !window.location.href.includes("/promolink") &&
        !window.location.href.includes("/boardGroupPromolink")) ||
        (JSON.parse(localStorage.getItem("user")) &&
          !(
            this.router.url === "/homePage" ||
            this.router.url.includes("/clicktocall") ||
            this.router.url === "/" ||
            this.router.url === "/user-homePage" ||
            this.router.url.includes("/liveshop") ||
            this.router.url.includes("boost-dashboard") ||
            this.router.url.includes("/3Dmodel") ||
            window.location.href.includes("/promolink") ||
            window.location.href.includes("/boardGroupPromolink")
          )))
    );
  }

  setDimensions() {
    const dimensions = setActualDimensions();
    this.windowHeight = dimensions.windowHeight;
    this.windowWidth = dimensions.windowWidth;
  }
  isMobileDevice() {
    return this.windowWidth <= 6;
  }
  isTabDevice() {
    return this.windowWidth > 6 && this.windowWidth <= 12;
  }
  scrollTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
    this.isTop = true;
  }
  goToHome() {
    if (!this.isUserConsumer()) {
      if (localStorage.getItem("retailerToken")) {
        this.router.navigateByUrl("/homePage");
      } else if (localStorage.getItem("nVipaniwhiteshopkey")) {
        this.router.navigateByUrl("/user-homePage");
      } else {
        this.router.navigateByUrl("");
      }
    }
  }
  validMail() {
    let data = {};
    data["email"] = this.email;
    if (
      data &&
      Object.keys(data).length &&
      data["email"] &&
      data["email"].length > 0
    ) {
      this.emailInvalid = !this.regexService
        .getEmailRegex()
        .test(data["email"]);
      this.isOrderLinkFormInvalid = this.emailInvalid || this.nameInvalid;
      if (this.isOTPAuthEnabled && !this.isOrderLinkFormInvalid) {
        this.isOrderLinkFormInvalid =
          this.phoneNumberInvalid || !(this.phoneNumber?.length > 0);
      }
    } else {
      this.emailInvalid = false;
      this.isOrderLinkFormInvalid = true;
    }
  }

  validName() {
    var letters = /^[a-zA-Z0-9\s]*$/;
    this.nameInvalid =
      this.name && this.name.length ? !this.name.match(letters) : false;
    this.isOrderLinkFormInvalid = this.nameInvalid;
    if (this.isEmailAuthEnabled && !this.isOrderLinkFormInvalid) {
      this.isOrderLinkFormInvalid =
        this.emailInvalid || !(this.email?.length > 0);
    }
    if (this.isOTPAuthEnabled && !this.isOrderLinkFormInvalid) {
      this.isOrderLinkFormInvalid =
        this.phoneNumberInvalid || !(this.phoneNumber?.length > 0);
    }
  }

  formPhoneNumber() {
    if (
      this.phoneFormat &&
      (this.phoneFormat.nationalNumber?.length ||
        this.phoneFormat.number?.length)
    ) {
      this.phoneNumber = this.phoneFormat.nationalNumber
        ? this.phoneFormat.e164Number.slice(this.phoneFormat.dialCode.length)
        : this.phoneFormat.number;
      this.phoneNumberInvalid = this.phoneNumber?.length
        ? this.changeCountry()
        : false;
      this.isOrderLinkFormInvalid = this.phoneNumberInvalid || this.nameInvalid;
      if (this.isEmailAuthEnabled && !this.isOrderLinkFormInvalid) {
        this.isOrderLinkFormInvalid =
          this.emailInvalid || !(this.email?.length > 0);
      }
    } else {
      this.phoneNumber = null;
      this.phoneNumberInvalid = false;
      this.isOrderLinkFormInvalid = true;
    }
  }

  changeCountry() {
    if (
      this.phoneFormat &&
      this.phoneFormat.countryCode === "DE" &&
      this.phoneFormat.dialCode === "+49"
    ) {
      return this.phoneNumber.length < 6 || this.phoneNumber.length > 13;
    } else if (
      this.phoneFormat &&
      this.phoneFormat.countryCode === "IN" &&
      this.phoneFormat.dialCode === "+91"
    ) {
      return this.phoneNumber.length !== 10;
    } else {
      return this.phoneNumber.length < 6 || this.phoneNumber.length > 13;
    }
  }

  async getPreviewData() {
    if (
      this.name?.trim() &&
      this.name?.length &&
      !this.isOrderLinkFormInvalid &&
      (this.email?.length || this.phoneNumber?.length)
    ) {
      let data = {};
      if (this.email) {
        data["email"] = this.email;
      }
      if (this.phoneNumber) {
        data["mobile"] = this.phoneNumber;
      }
      data["username"] = data["email"] || data["mobile"];
      data["name"] = this.name.trim();
      data["linkCode"] = this.linkCode;
      data["businessUnit"] = this.businessUnit;

      let currentUrl = new URL(window.location.href);
      const params = currentUrl.searchParams;
      let businessUnit = params.get("businessUnit");
      let url = params.get("domailURL");
      sessionStorage.setItem("businessUnit", businessUnit);
      localStorage.setItem("c2cKey", url);
      localStorage.setItem("userMail", this.email);
      this.isDialogOpen = true;
      data["ipAddress"] = this.dataIpAddress;
      data["address"] = this.dataAddress;
      this.checkLinkStatus(data);
    }
  }
  trimInput(type) {
    switch (type) {
      case "name":
        this.name = this.name?.trim();
        break;
      default:
        break;
    }
  }
  checkLinkStatus(data) {
    this.slotService.geoCodeData = data.address;
    this.slotService.ipAddressData = data.ipAddress;
    if (!this.isProceeded) {
      this.isProceeded = true;
      this.slotService.checkLinkData(data).subscribe(
        (result) => {
          if (!result["orderLink"]?.seller?.salePerson) {
            result["orderLink"].seller["salesPerson"] = this.spDetails;
          }
          this.getPrimarySalesPersonId(result);
          this.slotService.secondarySalePerson =
            result["orderLink"]?.seller?.secondarySalePerson;
          this.slotService.tertiarySalePerson =
            result["orderLink"]?.seller?.tertiarySalePerson;
          result["orderLink"]["spDetails"] = this.spDetails;
          this.apiCollectionService.spDetails = this.spDetails;
          if (Object.keys(result).length) {
            this.selectionPreview = false;
            this.promoLinkAuthorizationService.getCartData({
              data: result,
              email: this.email,
              mobile: this.phoneNumber,
            });
          }
        },
        (err) => {
          this.toastrService.error("No order link for this email", null, {
            timeOut: 2000,
          });
          this.router.navigateByUrl("/");
        }
      );
    }
  }
  getVideoURL(url: any) {
    if (!this.videoIndex) {
      this.bannerImage = this.embedVideoService.embed(url, {
        attr: {
          width: "100%",
          height: "100%",
          allow:
            "accelerometer; encrypted-media; gyroscope; playsinline; autoplay",
        },
        query: {
          autoplay: 1,
          mute: 1,
          enablejsapi: 1,
          modestbranding: 1,
          autohide: 1,
          showinfo: 0,
          fs: 0,
          playsinline: 1,
          allowfullscreen: 0,
        },
      });
      this.videoIndex++;
    }
    return this.bannerImage;
  }

  sanitize(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  clickRegistration(type, back?) {
    if (back) {
      this.isRegistrationSelected = false;
      this.email = "";
      this.name = "";
      this.phoneNumber = "";
      if (this.phoneFormat) {
        this.phoneFormat.nationalNumber = "";
        this.phoneFormat.internationalNumber = "";
        this.phoneFormat.number = "";
        this.phoneFormat.e164Number = "";
      }
      this.phoneNumberInvalid = false;
      this.emailInvalid = false;
      if (!this.isMobileDevice() && !this.isTabDevice()) {
        this.isStopMovement = false;
      }

      this.backCount++;
    } else {
      if (!this.backCount) {
        if (type === true) {
          this.isStopMovement = true;
          if (!this.isMobileDevice() && !this.isTabDevice()) {
            document.querySelectorAll(".target").forEach((single) => {
              TweenMax.to(single.querySelector(".text"), 0.2, {
                x: -15,
                y: -15,
              });
              setTimeout(() => {
                this.isRegistrationSelected = type;
                setTimeout(() => {
                  var nameInput = this._document.getElementById("nameTag");
                  nameInput.focus();
                }, 100);
              }, 1000);
            });
          } else {
            this.isRegistrationSelected = type;
          }
        }
      } else {
        this.isRegistrationSelected = false;
        this.backCount = 0;
      }
    }
  }

  isUserConsumer() {
    let index = -1;
    try {
      let user = JSON.parse(localStorage.getItem("user"));
      if (!localStorage) {
        this.isCookiesEnabled = false;
      }
      if (user && user.companies && user.companies.length) {
        index = user.companies.findIndex((company) => company.consumer);
      }
      if (index < 0 && user?.type && user.type === "B2C") {
        index = 0;
      }
      return index >= 0;
    } catch (e) {
      this.isCookiesEnabled = false;
      return;
    }
  }

  getCompanyLiveUrl() {
    let config = localStorage.getItem("config")
      ? JSON.parse(localStorage.getItem("config"))
      : JSON.parse(localStorage.getItem("companyConfig"));
    if (config && config.whiteshop && config.whiteshop.clickToCall) {
      this.companyLiveUrl = config.whiteshop.clickToCall.originUrl;
    }
    return this.companyLiveUrl;
  }

  goToWidget() {
    window.location.assign(this.getCompanyLiveUrl());
  }

  getPrimarySalesPersonId(result) {
    this.slotService.salesPersonId =
      result["orderLink"] &&
      result["orderLink"].seller &&
      result["orderLink"].seller.salesPerson
        ? result["orderLink"].seller.salesPerson._id
        : result["orderLink"].seller.user
        ? result["orderLink"].seller.user
        : "";
  }

  checkCompanyCreation() {
    if (this.router.url.includes("my-company/createCompany")) {
      return true;
    }
  }

  enableCookies() {
    let cookieDialogConfig = new MatDialogConfig();
    cookieDialogConfig.maxHeight = "100vh";
    cookieDialogConfig.maxWidth = "100vw";
    cookieDialogConfig.width = "100vw";
    cookieDialogConfig.height = "95vh";
    cookieDialogConfig.position = { bottom: "0" };
    cookieDialogConfig.disableClose = false;
    cookieDialogConfig.data = { isLogin: true };
    cookieDialogConfig.hasBackdrop = false;
    let loginDialog = this.dialog.open(
      EnableCookiesComponent,
      cookieDialogConfig
    );
  }
}
